import { Link } from "react-router-dom";
import { ChevronRightIcon } from "../lib/icons.js";

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }): JSX.Element {
  return (
    <nav aria-label="Breadcrumbs" className="text-sm">
      {/* flex-wrap: tri urovne drobecku se na 375 px do radky nevejdou. */}
      <ol className="flex flex-wrap items-center gap-1.5 text-zinc-500">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="hover:text-ktm-orange transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-zinc-900 font-medium" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && <ChevronRightIcon size={14} className="text-zinc-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
